module.exports = __webpack_public_path__ + "media/images/affiliate-background-591c3716cab1f74cfcad6122dc5603c7.jpg";